import { render, staticRenderFns } from "./selectHead.vue?vue&type=template&id=27c52642&"
import script from "./selectHead.vue?vue&type=script&lang=js&"
export * from "./selectHead.vue?vue&type=script&lang=js&"
import style0 from "./selectHead.vue?vue&type=style&index=0&id=27c52642&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports